"use client";

import dynamic from "next/dynamic";
import { SlideContent, type SlideData } from "./CoursePromoBannerSlide";
import styles from "./CoursePromoBanner.module.scss";

interface SwiperRawItem {
  Tag?: string;
  TagHash?: string;
  sublabeltext?: string;
  Heading?: string;
  duration?: string;
  star?: string;
  ShortDescription?: string;
  link?: string;
  backgroundImage?: { data?: { attributes?: { url?: string } } };
}

interface CoursePromoBannerProps {
  slides?: SwiperRawItem[];
}

function mapSlide(s: SwiperRawItem): SlideData {
  return {
    badge: s.Tag,
    badgeColor: s.TagHash,
    partner: s.sublabeltext,
    title: s.Heading,
    duration: s.duration,
    rating: s.star,
    learners: s.ShortDescription,
    ctaText: "Explore",
    ctaHref: s.link,
    backgroundImage: s.backgroundImage?.data?.attributes?.url,
  };
}

const DEFAULT_SLIDES: SwiperRawItem[] = [
  {
    Tag: "NEW",
    TagHash: "#22c55e",
    sublabeltext: "with School of AI",
    Heading: "Data Science & AI Certification",
    duration: "6 Months",
    star: "4.8",
    ShortDescription: "52K+ learners",
    link: "#",
    backgroundImage: {
      data: {
        attributes: {
          url: "https://amityonline.com/_s/Data_Science_Cerification_0fa20611e4.webp",
        },
      },
    },
  },
];

// Swiper only loaded when CMS returns 2+ slides — avoids Swiper JS/CSS on
// the common single-slide case while keeping identical slide markup.
const CoursePromoBannerCarousel = dynamic(
  () => import("./CoursePromoBannerCarousel"),
  { ssr: true },
);

const CoursePromoBanner: React.FC<CoursePromoBannerProps> = ({
  slides = DEFAULT_SLIDES,
}) => {
  const mappedSlides = slides.map(mapSlide);
  const isSingleSlide = mappedSlides.length <= 1;

  return (
    <section className={styles.promoBanner} aria-label="Course Promo">
      {isSingleSlide ? (
        <SlideContent slide={mappedSlides[0]} />
      ) : (
        <CoursePromoBannerCarousel slides={mappedSlides} />
      )}
    </section>
  );
};

export default CoursePromoBanner;
